module.exports = __webpack_public_path__ + "img/fsfpzn.38ef7ba2.png";